/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const routinePendingCancelBodyExpectedVersionExclusiveMin = 0;
export const routinePendingCancelBodyExpectedVersionMax = 9007199254740991;

export const routinePendingCancelBodyPreviewFingerprintMax = 256;

export const routinePendingCancelBodyConfirmNewGapsDefault = false;
export const RoutinePendingCancelBody = zod.object({
  expectedVersion: zod
    .int()
    .gt(routinePendingCancelBodyExpectedVersionExclusiveMin)
    .max(routinePendingCancelBodyExpectedVersionMax),
  previewFingerprint: zod.string().min(1).max(routinePendingCancelBodyPreviewFingerprintMax),
  confirmNewGaps: zod.boolean().default(routinePendingCancelBodyConfirmNewGapsDefault),
});

export type RoutinePendingCancelBody = zod.input<typeof RoutinePendingCancelBody>;
export type RoutinePendingCancelBodyOutput = zod.output<typeof RoutinePendingCancelBody>;
